/** Shared avatar color/initials helpers for the Inbox. */

const AVATAR_COLORS = [
  '#0f4c81', // cb-navy
  '#f26b1d', // cb-orange
  '#0e7490', // teal-700
  '#7c3aed', // violet-600
  '#b45309', // amber-700
  '#0f766e', // teal-600
  '#be185d', // pink-700
  '#1d4ed8', // blue-700
];

/** Deterministic background color from a string. */
export function avatarColor(str) {
  let h = 0;
  for (let i = 0; i < (str || '').length; i++) {
    h = str.charCodeAt(i) + ((h << 5) - h);
  }
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}

/** Up to 2 uppercase initials from a name or phone. */
export function avatarInitials(name) {
  if (!name) return '?';
  if (/^\+?\d[\d\s\-().]+$/.test(name.trim())) {
    return name.replace(/\D/g, '').slice(-2) || '#';
  }
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
